import Agent from "altus-agent";

import config from "infrastructure/config";
import authService from "services/auth.service";

export default new Agent(config, authService);
